import * as React from 'react';
import translate from '../../locale/translate';
import assign = require('object-assign');

import { ReportTemplate } from '../../store/models';

const Dialog = require('rc-dialog');

interface IProps {
    active: boolean,
    onOpen: Function,
    onClose: Function,
    onRemove: Function,
    templates: ReportTemplate[]
}

interface IState {
    requestDeleteTemplate: ReportTemplate;
    performDeleteTemplate: ReportTemplate;
}

export default class OpenModal extends React.Component<IProps, IState> {
    constructor(props) {
        super(props);
        this.state = {
            requestDeleteTemplate: null,
            performDeleteTemplate: null,
        };
    }

    openEmpty() {
        this.props.onOpen();
    }

    requestDelete(template: ReportTemplate) {
        this.setState({
            requestDeleteTemplate: template,
            performDeleteTemplate: null,
        });
    }

    confirmDelete(template: ReportTemplate) {
        this.props.onRemove(template);

        this.setState({
            requestDeleteTemplate: null,
            performDeleteTemplate: template,
        });
    }

    renderCopyButton(template: ReportTemplate) {
        if (template.rtId) {
            const copyProps = {
                defaultTemplateId: `copy-${template.rtId}`,
                name: [translate.gettext("Copy"), template.name].join(' - '),
            }

            const copy = assign({}, template, copyProps);

            delete copy.rtId;

            return <a onClick={() => this.props.onOpen(copy)} title={translate.gettext('Open as copy')}>
                <i className="fa fa-fw fa-clone" />
            </a>
        }

        return null;
    }

    renderDeleteButton(template: ReportTemplate) {
        if (this.state.requestDeleteTemplate === template) {
            return (
                <a onClick={() => this.confirmDelete(template)}>
                    {translate.gettext("Confirm delete")}
                    <i className="fa fa-fw fa-thumbs-up m-l-xxs" />
                </a>
            );
        } else if (this.state.performDeleteTemplate === template) {
            return <i className="fa fa-fw fa-spin fa-circle-o-notch" />;
        } else {
            return (
                <a onClick={() => this.requestDelete(template)}>
                    <i className="fa fa-fw fa-trash-o" />
                </a>
            );
        }
    }

    render() {
        const {active, templates, onOpen, onClose, onRemove} = this.props;
        const header = translate.gettext("Open template");

        return (
            <Dialog
                title={header}
                className="no-padding"
                onClose={onClose}
                visible={active}
            >
                <table className="table">
                    <tbody>
                        <tr>
                            <td colSpan={2}><a onClick={this.openEmpty.bind(this)}>{translate.gettext("Open empty template")}</a></td>
                        </tr>
                        {
                            templates.map(template => {
                                const key = template.rtId || template.defaultTemplateId;

                                return <tr key={key}>
                                    <td className="col-xs-8">
                                        <a onClick={() => onOpen(template)}>{template.name}</a>
                                    </td>
                                    <td className="col-xs-8 text-right">
                                        {this.renderCopyButton(template)}
                                        {this.renderDeleteButton(template)}
                                    </td>
                                </tr>;
                            })
                        }
                    </tbody>
                </table>
            </Dialog>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/modal/OpenModal.tsx